<template>
  <div>
    <tabela-filiais-mapeadas />
  </div>
</template>

<script>
import TabelaFiliaisMapeadas from "./FiliaisMapeadas";
export default {
  name: "Index",
  components: {TabelaFiliaisMapeadas}
}
</script>

<style scoped>

</style>
